/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountCredentialsForNewrelic extends models.ServiceAccountCredentialsBase {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountCredentialsForNewrelic");
    }

    getFixupPrototypeFunction() { return ServiceAccountCredentialsForNewrelic.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountCredentialsForNewrelic>): ServiceAccountCredentialsForNewrelic {
        let obj = Object.assign(new ServiceAccountCredentialsForNewrelic(), model);
        ServiceAccountCredentialsForNewrelic.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountCredentialsForNewrelic>): ServiceAccountCredentialsForNewrelic {
        if (!model) return null;
        return ServiceAccountCredentialsForNewrelic.newInstance(<ServiceAccountCredentialsForNewrelic> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountCredentialsForNewrelic) {
        if (!obj) return;

        models.ServiceAccountCredentialsForNewrelic.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountCredentialsForNewrelic): boolean {
        if (models.ServiceAccountCredentialsBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountCredentialsForNewrelic.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * User API Key. This is a required field.
     */
    user_api_key: string;

    /**
     * NewRelic URL. This is a required field.
     */
    newrelic_url: string;

    /**
     * Cloud Provider. This is a required field.
     */
    service_account_type: models.CloudServiceName;

    /**
     * ServiceAccount Id. This is a required field.
     */
    service_account: string;

}
